import {ImageLoader} from "../common/ImageLoader";

export const CategoryIconItem = ({name, src, href, ...props}) => (
    <a
        href={href}
        className="w-24 flex flex-col items-center text-center cursor-pointer !no-underline shrink-0"
        {...props}
    >
        <div
            className="w-20 h-20 rounded-full bg-white mb-2 border border-base-200 flex items-center justify-center overflow-hidden transition-transform hover:scale-105"
        >
            <ImageLoader
                src={src || "https://via.placeholder.com/80"}
                alt={name}
                loading="lazy"
                className="max-w-[70%] max-h-[70%] object-contain"
                skeletonClassName="w-16 h-16 rounded-full"
            />
        </div>

        <div className="text-sm leading-tight break-words whitespace-normal px-1 line-clamp-2">
            {name}
        </div>
    </a>
);